
import { MANAGE_SAA_QUERY_REQUEST, MANAGE_SAA_QUERY_SUCCESS, MANAGE_SAA_QUERY_FAILURE } from '../actions/saa-internal-portal-action-types';

const INITIAL_MANAGE_INTERNAL_PORTAL_STATE = {
	isLoading: false,
	results: {},
	error: '',
};

export function manageInternalPortalReducer(state = INITIAL_MANAGE_INTERNAL_PORTAL_STATE, action) {
	switch (action.type) {
		// case types.CREATE_GENESIS_USER_RESET:
		// 	return INITIAL_CREATE_GENESIS_USER_ORG_STATE;
		case MANAGE_SAA_QUERY_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case MANAGE_SAA_QUERY_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case MANAGE_SAA_QUERY_FAILURE:
			return { ...state, isLoading: false, error: 'Error accessing internal portal' };
		default:
			return state;
	}
}

